import { isRestApiServerError } from '@/utils/useRestApiServerErrorHandling';

import { DEFAULT_PANEL_WIDTH, EXPANDED_PANEL_WIDTH } from './constants';
import { ExcelState } from './types';

export const DEFAULT_MANUAL_PLOT_NAME = 'New plot';
export const NONE_COLUMN = '__none__';
export const UNKNOWN_ERROR_KEY = 'shared.uploadCoordinates.error.unknown' as const;

export const LANDLER_FIELDS = ['name', 'id', 'land_steward_name', 'label'] as const;
export type LandlerField = (typeof LANDLER_FIELDS)[number] | 'none';

export function autoMapColumn(col: string): LandlerField {
  const lower = col.toLowerCase();
  if (/^name/.test(lower)) return 'name';
  if (/^id$/.test(lower)) return 'id';
  if (/steward/.test(lower)) return 'land_steward_name';
  if (/label|tag/.test(lower)) return 'label';
  return 'none';
}

export function parseLatLng(latStr: string, lngStr: string) {
  const lat = parseFloat(latStr);
  const lng = parseFloat(lngStr);

  if (Number.isNaN(lat) || Number.isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return null;
  }

  return { lat, lng };
}

export function extractServerError(error: unknown, fallback: string): string {
  if (isRestApiServerError(error) && error.formErrors[0]?.messages[0]) {
    return error.formErrors[0].messages[0];
  }

  return fallback;
}

export function getExcelColumns(state: ExcelState | null): string[] {
  if (!state) return [];

  return state.columnsBySheet[`${state.selectedSheet}`] ?? state.columnsBySheet[''] ?? [];
}

export function snapPanelWidth(currentWidth: number, moved: boolean): number {
  const midpoint = (DEFAULT_PANEL_WIDTH + EXPANDED_PANEL_WIDTH) / 2;

  if (moved) {
    return currentWidth < midpoint ? DEFAULT_PANEL_WIDTH : EXPANDED_PANEL_WIDTH;
  }

  return currentWidth === DEFAULT_PANEL_WIDTH ? EXPANDED_PANEL_WIDTH : DEFAULT_PANEL_WIDTH;
}
